import Api from '@/services/Api'

export default {
  // Método que llama a la url para crear un chat
 getLaboratoryExams () {
   return Api().get("/laboratory-exams");
},
  updateLaboratoryExam (params) {
    return Api().put("/laboratory-exams",params);
  },
  addLaboratoryExam (params) {
    return Api().post("/laboratory-exams",params);
  },
  getLaboratoryExam (params) {
    return Api().get("/laboratory-exams/"+params);
  },
  deleteLaboratoryExam (params) {
    return Api().delete("/laboratory-exams/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/LaboratoryExamService.js